module.exports = __webpack_public_path__ + "img/woman-in-computer.d257ef1.webp";